import type { HTMLAttributes, ReactNode } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export type BadgeTone =
  "neutral" | "wishlist" | "toRead" | "reading" | "complete" | "attention";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: BadgeTone;
}

const tones: Record<BadgeTone, string> = {
  neutral: "border-line bg-line/35 text-body",
  wishlist: "border-purple-200 bg-purple-50 text-purple-800",
  toRead: "border-sky-200 bg-sky-50 text-sky-800",
  reading: "border-amber-200 bg-amber-50 text-amber-800",
  complete: "border-emerald-200 bg-emerald-50 text-emerald-800",
  attention: "border-rose-200 bg-rose-50 text-rose-800",
};

export function Badge({ children, className, tone = "neutral", ...props }: BadgeProps) {
  return (
    <span
      className={twMerge(
        clsx(
          "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold shadow-sm before:h-1.5 before:w-1.5 before:rounded-full before:bg-current",
          tones[tone],
          className
        )
      )}
      {...props}
    >
      {children}
    </span>
  );
}
